import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import VoiturePage from './pages/VoiturePage';
import ClientPage from "./pages/ClientPage";
import ReservationPage from "./pages/ReservationPage";
import ReservationForm from "./components/ReservationForm";
import EditReservationForm from "./components/EditReservationForm";
import ReservationDetail from "./pages/reservationdetailspage";
import Finance from "./pages/Finance";
import EntretienPage from "./pages/EntretienPage";
import Calendrar from "./pages/calendrar";
import CarTransactions from './pages/CarTransactions';
import Locationpage from "./pages/locationpage";
import Historique from "./pages/locationhistorique";
import Dashboard from "./pages/dashboard";
import Statistics from "./pages/statistics";
import Account from "./pages/Account";
import { DataProvider } from './context/DataContext';


// Route Protection Components
const PrivateRoute = ({ children }) => {
        const token = localStorage.getItem('token');
        return token ? children : <Navigate to="/" />;
};

const AdminRoute = ({ children }) => {
        const token = localStorage.getItem('token');
        const userRole = localStorage.getItem('userRole');

        if (!token) {
                return <Navigate to="/" />;
        }

        if (userRole !== 'admin') {
                return <Navigate to="/dashboard" />;
        }

        return children;
};



function App() {
        return (
            <DataProvider>
                <Routes>
                        {/* Public route */}
                        <Route path="/" element={<Login />} />
    
                        {/* Protected routes with sidebar layout */}
                        <Route path="/*" element={
                                <PrivateRoute>
    
                                                <Routes>
                                                        {/* Common routes for all authenticated users */}
                                                        <Route path="/dashboard" element={<Dashboard />} />
                                                        <Route path="/voitures" element={<VoiturePage />} />
                                                        <Route path="/clients" element={<ClientPage />} />
                                                        <Route path="/reservations" element={<ReservationPage />} />
                                                        <Route path="/reservations/new" element={<ReservationForm />} />
                                                        <Route path="/reservations/:id/edit" element={<EditReservationForm />} />
                                                        <Route path="/reservations/:id/" element={<ReservationDetail />} />
                                                        <Route path="/entretien/" element={<EntretienPage />} />
                                                        <Route path="/calendar/" element={<Calendrar />} />
                                                        <Route path="/location/" element={<Locationpage />} />
                                                        <Route path="/historique/" element={<Historique />} />
                                                        <Route path="/account" element={
                                                                <AdminRoute>
                                                                <Account />
                                                                </AdminRoute>
                                                        } />
    
                                                        {/* Admin only routes */}
                                                        <Route path="/finance" element={
                                                                <AdminRoute>
                                                                        <Finance />
                                                                </AdminRoute>
                                                        } />
                                                        <Route path="/CarTransactions" element={
                                                                <AdminRoute>
                                                                        <CarTransactions />
                                                                </AdminRoute>
                                                        } />
                                                        <Route path="/statistics" element={
                                                                <AdminRoute>
                                                                        <Statistics />
                                                                </AdminRoute>
                                                        } />
    
                                                        {/* Catch all route - redirect to dashboard */}
                                                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                                                </Routes>
    
                                </PrivateRoute>
                        } />
                </Routes>
            </DataProvider>
        );
}

export default App;